if (!customElements.get('vbb-reactive-ingredient-technology')) {
  customElements.define('vbb-reactive-ingredient-technology', class ReactiveIngredientTechnology extends HTMLElement {
    constructor() {
      super();
      this.productFormId = this.dataset.productFormId;
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    handleVariantChange() {
      const newIngredientTechnologySelector = `[data-template="ingredient-technology"][data-variant-id="${this.productForm.activeVariantId}"]`;
      const newIngredientTechnologyContents = this.productForm?.querySelector(newIngredientTechnologySelector);
      const ingredientsListTitleEl = this.parentElement.previousElementSibling;

      if (ingredientsListTitleEl?.id === 'ingredient-technology-title') {
        ingredientsListTitleEl.innerText = this.productForm.activeVariant.ingredientsListTitle;
      }

      if (newIngredientTechnologyContents?.innerHTML != null) {
        this.innerHTML = newIngredientTechnologyContents.innerHTML;
      }
    }

    connectedCallback() {
      if (!this.productForm) {
        this.productForm = document.querySelector(`vbb-product-form-reactive[id="${this.productFormId}"]`);
        this.productForm.addEventListener('variant:changed', this.handleVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.productForm) {
        this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
      }
    }
  });
}
